import { slugify } from './slugify';

export const buildTestId = (...parts) =>
  parts
    .filter((part) => part !== undefined && part !== null && part !== '')
    .map(slugify)
    .filter(Boolean)
    .join('-');
